import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";  // Ensure Tailwind is working
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);